import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import classNames from 'classnames';
import { AtlNavIconContainerProps } from './nav-icon.props';
import { getGlobalStyleSheets } from '../../../global-styles';
import '../../tooltip';

import * as TagNames from '../layouts.tagnames';
import { DropDownMenuClickEvent } from '../../dropdownmenu';

@customElement(TagNames.NavIconContainer)
export class AtlNavIconContainer
   extends LitElement
   implements AtlNavIconContainerProps
{
   declare refId: string;
   declare name: string;
   declare selected: boolean;
   declare protected disabledTooltip: boolean;

   static properties = {
      refId: { type: String },
      name: { type: String },
      selected: { type: Boolean, state: true },
      disabledTooltip: { type: Boolean, state: true },
   };

   constructor() {
      super();
      window.addEventListener(DropDownMenuClickEvent.EVENT_NAME, ((
         event: DropDownMenuClickEvent
      ) => this._handleClick(event)) as EventListener);
   }

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
         .atl-tooltip-content {
            width: max-content;
         }
         .atl-wc-nav-item-container {
            display: flex;
            align-items: center;
            height: 100%;
         }
      `,
   ];

   render() {
      return html`
         <atlantis-tooltip ?disabledTooltip=${this.disabledTooltip}>
            <div
               class=${classNames('atl-wc-nav-item-container', {
                  'atl-wc-nav-item-container-selected': this.selected,
               })}
            >
               <slot></slot>
            </div>
            <div
               class="atl-tooltip-content"
               tabindex="0"
               slot="tooltip-content"
            >
               ${this.name}
            </div>
         </atlantis-tooltip>
      `;
   }

   protected _handleClick = (e: DropDownMenuClickEvent) => {
      if (e?.detail?.id !== this.refId) return;

      this.disabledTooltip = e?.detail?.payload;
   };
}
